import { defineComponent, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash';
import { SettingTable, SettingTableRow, BasicInput } from '@hems/component';
import { DateHelper, useLocale, useGenType, useACDeviceType } from '@hems/util';
import { EMS_TYPE, NETWORK_TYPE } from '@hems/util/src/constant';
export default defineComponent({
    name: 'ProductInfo',
    components: {
        SettingTable,
        SettingTableRow,
        BasicInput,
    },
    setup() {
        const { isFoxESSType } = useGenType();
        const store = useStore();
        const EMPTY_TEXT = '-';
        const defaultInstallationInfo = {
            device_id: '',
            site_id: 0,
            fox_box_id: '',
            pv_cap: 0,
            bat_cnt: 0,
            pem_mode: false,
            install_dt: '',
            warrenty_dt: '',
            timezone: '',
            latitude: 0,
            longitude: 0,
            address: '',
            installer_name: '',
            installer_company: '',
            installer_email: '',
            installer_tel_num: '',
            gateway_connection: false,
            product_model_nm: '',
            ems_ver: '',
            ems_type_cd: EMS_TYPE.STAND_ALONE,
            sim_card_id: '',
            lte_modem_id: '',
            data_plan_start_date: null,
            data_plan_end_date: null,
            network_type: NETWORK_TYPE.UNKNOWN,
        };
        const state = reactive({
            data: store.state.device.installation ?? defaultInstallationInfo,
            service: 'Q CELLS',
            installed_date: '',
        });
        const { isUS } = useLocale();
        const { isSolarConfig } = useACDeviceType();
        const dataPlanSubscriptionRange = computed(() => {
            if (!state.data.data_plan_start_date || !state.data.data_plan_end_date) {
                return '';
            }
            return `${getformattedDataPlanValue(state.data.data_plan_start_date)} - ${getformattedDataPlanValue(state.data.data_plan_end_date)}`;
        });
        const getformattedDataPlanValue = (dataPlanDate) => {
            return DateHelper.getLocalDate(dataPlanDate, { isTime: false, isSecond: false });
        };
        const isCellularCustomer = computed(() => state.data.sim_card_id);
        function getformattedDateValue() {
            if (state.data?.install_dt) {
                state.installed_date = DateHelper.getLocalDate(state.data.install_dt, { isTime: true, isSecond: false });
            }
        }
        function check3rdParty() {
            if (_.has(state.data, 'pem_mode')) {
                state.service = !state.data?.pem_mode ? 'Q CELLS' : '3rd Party';
            }
            else if (_.has(state.data, 'gateway_connection')) {
                state.service = !state.data?.gateway_connection ? 'Q CELLS' : '3rd Party';
            }
        }
        check3rdParty();
        getformattedDateValue();
        return {
            state,
            dataPlanSubscriptionRange,
            isUS,
            NETWORK_TYPE,
            isFoxESSType,
            isCellularCustomer,
            EMPTY_TEXT,
            isSolarConfig,
        };
    },
});
